// Vanilla CSS for the assignment KIND marker. Prefix: akc-
//
// One small overline per ödev row. Deliberately NOT glass: it renders once per card in a
// long list, and a per-row backdrop-filter is exactly the scroll jank the homework cards
// were flattened to remove (see --glass-flat-solid).
//
// The kind is ACHROMATIC by design. Hue on an ödev card already names the DERS: the
// coterie ink drives the 4px left rail, the tint gradient, the subject label and the
// progress fill. Measuring the four old kind hues against the ten coterie ink families
// (SubjectUtilization.SUBJECT_STYLE) gave 40 pairings, of which 9 sat within 25° of hue
// and 6 were the SAME hue to within 6° — Şube×Fizik and Grup×Fen were exactly 0°,
// Bireysel×Matematik 5°, Sınav×Coğrafya 6°. On those cards the marker dissolved into its
// own background. So kind gives hue up entirely and differentiates on the ICON
// silhouette (buildings / users / user / exam) plus its word.
//
// This is the same reasoning .qdd-tag--upcoming and .qak-status--upcoming already
// applied when they went slate — "free of every subject/coterie color … so it never
// blends into the card's subject theme".
//
// No pill: the marker owns its own line in each card's meta rail (.qdd-hw-rail /
// .qdf-hw-rail / .qak-item-rail), and a label that owns a line wants tracking rather
// than a container.
//
// ALL FOUR kinds share this one treatment — the ICON and the word are the whole
// differentiation. Sınav is deliberately NOT singled out with a colour: an earlier draft
// gave it --catchup-gray-600 against the siblings' --catchup-gray-500, which measures
// 1.23:1 — imperceptible, so it claimed a distinction it did not deliver. Without a
// container to invert there is no room for a visible colour break here; if the "a sınav
// is not an ödev" distinction is wanted on these surfaces it needs its own design pass,
// not a shade.
//
// text-transform depends on <html lang> for correct Turkish casing ("Şube ödevi" →
// "ŞUBE ÖDEVİ", not "ŞUBE ÖDEVI"). public/index.html ships lang="tr" and App.tsx keeps
// it in sync with the selected language — if that ever stops, this label silently
// mis-cases the dotted İ.
export const assignmentKindChipStyles = `
  .akc-chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
    /* --fs-sm (11px), not --fs-xs (9px): the kind is a permanent identity and the status
       tag on the same rail is --fs-sm, so at 9px the transient state outranked it. */
    font-size: var(--fs-sm);
    font-weight: 700;
    line-height: 1;
    letter-spacing: 0.09em;
    text-transform: uppercase;
    white-space: nowrap;
    color: var(--catchup-gray-500);
  }
  .akc-chip svg {
    opacity: 0.85;
  }
`;
